import { Text } from '@querodelivery/uni-react';
import styles from './mission-data-box.module.scss';

interface MissionDataBoxProps {
  label: string;
  value: string;
  supportLabel?: string;
}

export const MissionDataBox = ({
  label,
  value,
  supportLabel,
}: MissionDataBoxProps) => {
  return (
    <div className={styles.missionDataBox}>
      <Text variant="bodyXs" tone="supporting" fontWeight="medium">
        {label}
      </Text>
      <Text variant="heading2xl" tone="secondary" fontWeight="bold">
        {value}
      </Text>
      {supportLabel && (
        <Text variant="bodyXs" tone="highlight" fontWeight="medium">
          {supportLabel}
        </Text>
      )}
    </div>
  );
};
